import { render } from "./beforeAfterOne.vue?vue&type=template&id=907c6e8c"
import script from "./beforeAfterOne.vue?vue&type=script&lang=js"
export * from "./beforeAfterOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__